import styled, { keyframes, FlattenSimpleInterpolation, css } from 'styled-components';
import { ColorModeBgPropKeys, ColorModeFgPropKeys } from 'styles/colors';
import { cssVar, mediaQuery } from 'styles/helper';

export const topInfoBarTransitionTime = 500;

const slideIn = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`;

interface InfoBarContainerProps {
  $customStyles?: FlattenSimpleInterpolation;
  $background: ColorModeBgPropKeys | ColorModeFgPropKeys;
  $dismissible: boolean;
}

export const InfoBarContainer = styled.div<InfoBarContainerProps>`
  transition: margin-top ${topInfoBarTransitionTime}ms ease-in-out;
  z-index: 102;
  animation-name: ${slideIn};
  animation-duration: 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  position: relative;
  padding: ${cssVar('spacing-lg')} ${cssVar('spacing-4xl')};
  box-sizing: border-box;

  ${({ $background }) => css`
    background-color: ${cssVar($background)};
  `}

  ${({ $dismissible }) =>
    mediaQuery(
      'sm',
      css`
        padding: ${cssVar('spacing-xl')};

        ${!$dismissible
          ? ''
          : css`
              padding-top: ${cssVar('spacing-4xl')};
            `}
      `
    )}

  ${({ $customStyles = '' }) => $customStyles}
`;

export const DismissContainer = styled.div`
  position: absolute;
  right: ${cssVar('spacing-lg')};
  top: 50%;
  transform: translateY(-50%);

  ${mediaQuery(
    'sm',
    css`
      top: 0;
      transform: translateY(0);
    `
  )}
`;
